// 已选择的条件
import React from 'react'
import { useRouter } from 'next/router'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import buildUrl from 'Pages/auto/home/utils'
import { ContextStore } from './reducer'
import { IConditionsProps } from './interface'

interface IProps {
  conditions: IConditionsProps[]
}

export default function Select({ conditions }: IProps) {
  const { state, dispatch } = React.useContext(ContextStore)
  const router = useRouter()
  const entries = Object.entries(state)
  const filterList = ['sort', 'sub_brand_id']
  const allConditionKeys = React.useMemo(() => {
    return conditions.map(item => {
      return Array.from(
        new Set(item.data.map(item => item.key).filter(item => !!item))
      )
    })
  }, [conditions])

  if (
    !entries ||
    !entries.length ||
    !entries.filter(([key]) => filterList.indexOf(key) === -1).length
  ) {
    return null
  }

  return (
    <div className="selected clearfix">
      <span className="label fl">已选条件：</span>
      <span
        className="reset"
        onClick={() => {
          sendTeaCommEvent('click_garage_series_selector_clear')
          window.location.href = `/auto/library/x-x-x-x-x-x-x-x-x-x-x`
        }}
      >
        <span className="icon-delete-ic empty-icon" />
        清空条件
      </span>
      <div className="conditions">
        {Object.entries(state).map(([key, value]) => {
          if (filterList.indexOf(key) > -1) {
            return null
          }
          if (!value || !value.length) {
            return null
          }
          return value.map(item => (
            <span
              key={item.text}
              className="container"
              onClick={(e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
                e.stopPropagation()
                e.preventDefault()
                const newOption = {
                  ...state,
                }
                delete newOption[key]
                router.push(
                  `/auto/xxxx/${buildUrl(newOption, allConditionKeys)}${
                    key === 'brand' ? '' : window?.location?.search
                  }`,
                  `/auto/library/${buildUrl(newOption, allConditionKeys)}${
                    key === 'brand' ? '' : window?.location?.search
                  }`
                )
              }}
            >
              {item.text}
              <span className="icon-dislike-ic delete-icon" />
            </span>
          ))
        })}
      </div>
      <style jsx>
        {`
          .selected {
            margin: -1px 20px 0;
            border-radius: 4px;
            border: 1px solid #ededed;
          }
          .label {
            display: inline-block;
            margin: 12px 2px 12px 8px;
            color: #666;
          }
          .reset {
            float: right;
            margin: 12px 8px 12px 0;
            cursor: pointer;
          }
          .empty-icon {
            font-size: 24px;
            margin-top: -6px;
            margin-right: 4px;
          }
          .reset:hover {
            color: #406599;
          }
          .conditions {
            width: 700px;
            min-height: 36px;
            margin: 8px 0 0 80px;
          }
          .conditions span.container {
            display: inline-block;
            padding: 4px 4px 4px 8px;
            margin-right: 8px;
            margin-bottom: 8px;
            border-radius: 4px;
            background-color: rgba(255, 225, 0, 0.2);
            cursor: pointer;
          }
          .delete-icon {
            font-size: 16px;
            margin-left: 4px;
            margin-top: -2px;
          }
        `}
      </style>
    </div>
  )
}
